export default __webpack_public_path__ + "74b692c0da44210c9078ac59035048dc.safari.png";